module.exports = __webpack_public_path__ + "prod/20261104151832/img/logo_v2.a0a47605.png";